import { formatBanner } from "./identity";

export const formatTeam = (data: IResponseTeam): IModelIdentityItem => {
  const runtimeConfig = useRuntimeConfig().public;
  const isEnableTeamShortName = runtimeConfig.APP_CUSTOMER.enable_teams_short_name;
  const title = isEnableTeamShortName && data.shortTitle ? data.shortTitle : data.title;

  const banners = data.content?.PosterF?.map(formatBanner) || [];
  const mobileBanners = data.content?.MobilePosterF?.map(formatBanner) || [];

  const logoUrl = data.content?.PosterH?.[0]?.url || "";

  return {
    id: data._id,
    referenceId: data.referenceId,
    title,
    imageUrl: data.logo,
    bannerUrl: data.banner,
    color: data.color,
    identityIds: data.identities?.map(i => i.type) || [],
    facebookUrl: data.socialMediasLinks?.facebook,
    instagramUrl: data.socialMediasLinks?.instagram,
    xUrl: data.socialMediasLinks?.twitter,
    webUrl: data.socialMediasLinks?.web,
    banners,
    teamRoster: data.teamRoster || [],
    mobileBanners,
    logoUrl,
  };
};

export const formatTeamWithLeagueSearch = (data: IResponseLeagueWithTeamsSearch): IModelIdentityWithIdentityItemsSearch => {
  const identityItems = data.teams.map((item) => {
    const runtimeConfig = useRuntimeConfig().public;
    const isEnableTeamShortName = runtimeConfig.APP_CUSTOMER.enable_teams_short_name;
    const title = isEnableTeamShortName && item.shortTitle ? item.shortTitle : item.title;

    return {
      id: item._id,
      title,
      imageUrl: item.logo,
    };
  });
  return {
    identityId: data._id,
    title: data.title,
    identityItems,
  };
};
